import { createContext } from 'react';

const ActionDrawerHoverContext = createContext({});

export default ActionDrawerHoverContext;
